import cookie from '@/plugins/cookie'

function decodeJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(atob(base64))
}

const routes = [
  {
    name: "admin",
    path: "admin",
    component: () => import("@/views/admin/TheIndex.vue"),
    meta: {
      isInMenu: true,
      title : 'main-menu.admin',
      access_control: ['ROLE_ADMIN'],
      requiresAuth: true,
      order: 3,
      icon: 'fas fa-tools',
    },
    children: 
    [
      {
        name: "mediaservers",
        path: "media-centers",
        component: () => import('@/views/servers/mediacenter/List.vue'),
        meta : {
          title : 'main-menu.configuration.servers.mediacenter',
          access_control : ['ROLE_ADMIN'],
          requiresAuth : true
        }
      },
      {
      name: "mediaserversNew",
      path: "media-centers/new",
      component: () => import('@/views/servers/mediacenter/Form.vue'),
        meta : {
          access_control : ['ROLE_ADMIN'],
          requiresAuth : true
        }
      },
      {
        name: "mediaserversEdit",
        path: "media-centers/:id/edit",
        component: () => import('@/views/servers/mediacenter/Form.vue'),
        meta : {
          access_control : ['ROLE_ADMIN'],
          requiresAuth : true
        },
        props: true,
      },
      {
          name: "ostickets",
          path: "mail-servers",
          component: () => import("@/views/servers/osticket/List.vue"),
          meta : {
            isInMenu : true,
            title : 'main-menu.configuration.servers.ostickets',
            access_control : ['ROLE_ADMIN'],
            requiresAuth : true
          }
        },
        {
        name: "osticketsNew",
        path: "mail-servers/new",
          component: () => import("@/views/servers/osticket/Form.vue"),
          meta : {
            access_control : ['ROLE_ADMIN'],
            requiresAuth : true
          }
        },
        {
          name: "osticketsEdit",
          path: "mail-servers/:id/edit",
          component: () => import("@/views/servers/osticket/Form.vue"),
          meta : {
            access_control : ['ROLE_ADMIN'],
            requiresAuth : true
          },
          props: true,
        },
        {
          name: "sign-in-art",
          path: "sign-in-art",
          component: () => import("@/views/general-configuration/TheSideImageConfiguration.vue"),
          meta: {
            isInMenu: true,
            title : 'main-menu.configuration.general',
            access_control: ['ROLE_ADMIN'],
            requiresAuth: true
          }
        },
        {
          name: "adminOrganizations",
          path: 'organizations',
          component: () => import("@/views/organizations/List.vue"),
        },
        {
          name: "organizationsNew",
          path: "organizations/new",
          component: () => import("@/views/organizations/Form.vue"),
        },
        {
          name: "organizationsEdit",
          path: "organizations/:id/edit",
          component: () => import("@/views/organizations/Form.vue"),
          props: true
        },
    ],
    beforeEnter: async (to, from, next) => {  
      const token = cookie.getCookie()

      if (!token) {
        next('home')
      }

      const user = decodeJwt(token)
      if (!user.roles || !user.roles.includes('ROLE_ADMIN')) {
        next('home')
      }
      
      next()
    }
  }
];

export default routes;
